import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  SelectedOrganisationId,
  selectUser,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  Journal,
  getJournalCaisseByIdApi,
} from "../../_App/Redux/Slices/journalCaisse/journalCaisseSlice";
import {
  ListJournalMouvementsCaisse,
  findMouvementsCaisseByJournalApi,
} from "../../_App/Redux/Slices/mouvementCaisse/MouvementCaisseSlice";
import {
  FactureProducts,
  ListJournalOrders,
  findFiltreSoldProductsApi,
  findOrdersByJournalApi,
} from "../../_App/Redux/Slices/Orders/OrderSlice";
import {
  formadate,
  formatFloat,
  generateUniqueCode,
} from "../../_App/Helpers/helpers";
import {
  ArticleData,
  OrderType,
} from "../../_App/Types/Entites/Orders/OrderType";
import ReactToPrint from "react-to-print";
import { Button } from "react-bootstrap";
import _ from "lodash";
import { PaymentType } from "../../_App/Types/Entites/PaymentType";
import {
  FactureItemType,
  FactureType,
} from "../../_App/Types/Entites/FactureType";
import {
  fetchFactures,
  getFactureByJournal,
  saveFactureApi,
  selectFactures,
} from "../../_App/Redux/Slices/facture/FactureSlice";
import Swal from "sweetalert2";

const FactureSansEspeces = () => {
  let { id } = useParams<{ id?: string }>();

  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const societe_id = useAppSelector(societeId);

  const journal = useAppSelector(Journal);
  const journalOrders = useAppSelector(ListJournalOrders);
  const user = useAppSelector(selectUser);
  const factures = useAppSelector(selectFactures);
  const products = useAppSelector(FactureProducts);

  const [filtre, setFiltre] = useState({
    organisation: currentOrganisation,
    dateFin: undefined,
    dateDebut: undefined,
    listcaissiers: [],
    listvendeur: [],
    status: undefined,
    type: undefined,
    numOrder: undefined,
    index: 1,
    keyword: "",
    societe_id: societe_id,
    journal_id: id,
  });

  const grouppingProducts = () => {
    let array: ArticleData[] = [];

    // Filter out orders that have only cash payments
    const filteredOrders = journalOrders.filter((order: any) => {
      // Check if there's at least one non-cash payment method in the order's payments
      console.log(order);
      return order.payments.some(
        (payment: PaymentType) => payment.payment_method !== "Espéces"
      );
    });
    // Now, map through the filtered orders to group products
    filteredOrders.forEach((order: any) => {
      if (order.status === "Payée") {
        order.items.forEach((item: ArticleData) => {
          console.log("iteeemmm ::::: ", item);
          // Check if sold_quantity is greater than 0 before proceeding
          if (!("sold_quantity" in item) || item.sold_quantity > 0) {
            const index = array.findIndex(
              (product) => product.article._id === item.article._id
            );
            if (index >= 0) {
              // Make sure ArticleData properties are not read-only
              array[index].quantity += item.quantity;
              array[index].prix_total += item.prix_total;
            } else {
              array.push({ ...item });
            }
          }
        });
      }
    });

    return array;
  };
  const [savedFacture, setSavedFacture] = useState<FactureType | undefined>(
    undefined
  );
  useEffect(() => {
    const fetchData = async () => {
      if (currentOrganisation && id) {
        await dispatch(findMouvementsCaisseByJournalApi(id));
        await dispatch(getJournalCaisseByIdApi(id));
        await dispatch(findOrdersByJournalApi(id));
        await dispatch(fetchFactures(null));
        const response = await dispatch(getFactureByJournal(id));
        console.log(response);
        if (response?.payload?.success) {
          setSavedFacture(response.payload.data[0]);
        }
      }
      await dispatch(findFiltreSoldProductsApi(filtre));
    };

    fetchData();
  }, [dispatch]);

  let date = new Date();

  const [checkedItems, setCheckedItems] = useState<any[]>([]);
  const [isPrinting, setIsPrinting] = useState(false);

  const handleCheckboxChange = (itemId: number) => {
    console.log("itemId", itemId);
    console.log("checkedItems", checkedItems);
    const isChecked = checkedItems.includes(itemId);
    console.log("isChecked", isChecked);
    if (isChecked) {
      setCheckedItems(checkedItems.filter((id) => id !== itemId));
    } else {
      setCheckedItems([...checkedItems, itemId]);
    }
  };

  const componentRef = useRef<HTMLDivElement>(null);

  function eliminateItemsFromArray1() {
    let itemsCopy: any[] = [];
    if (
      checkedItems.length &&
      products &&
      products.data &&
      Object.values(products.data)
    ) {
      itemsCopy = Object.values(products.data);
      return itemsCopy.filter((item: any) =>
        checkedItems.includes(item.product._id)
      );
    } else return Object.values(products.data);
  }

  const saveFacture = async (facture: FactureType) => {
    try {
      let items;
      if (eliminateItemsFromArray1().length) {
        items = eliminateItemsFromArray1();
      } else {
        items = Object.values(products.data);
      }
      const response = await dispatch(saveFactureApi({ facture, items }));
      if (response.payload.success) {
        // Check if the response indicates success
        // Show success alert
        Swal.fire({
          title: "Succès",
          text: "La facture a été enregistrée avec succès.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      } else {
        // Handle failure case
        Swal.fire({
          title: "Erreur",
          text: "Une erreur est survenue lors de l'enregistrement de la facture.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error saving facture:", error);
      Swal.fire({
        title: "Erreur",
        text: "Une erreur est survenue lors de l'enregistrement de la facture.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <div className="row invoice layout-spacing">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="doc-container">
            <div className="row">
              <div className="col-xl-12">
                <div className="invoice-container">
                  {savedFacture ? (
                    <div className="invoice-inbox" ref={componentRef}>
                      <div id="ct" className="">
                        <div className="invoice-00001">
                          <div className="content-section">
                            <div className="inv--head-section inv--detail-section">
                              <div className="row">
                                <div className="col-sm-6 col-12 mr-auto">
                                  <div className="d-flex">
                                    {/* <img
                                    className="company-logo"
                                    src="/assets/assets/img/logo.png"
                                    alt="company"
                                  /> */}
                                    <h3 className="in-heading align-self-center">
                                      {savedFacture.societe?.nom}
                                    </h3>
                                  </div>
                                </div>

                                <div className="col-sm-6 text-sm-right">
                                  <p className="inv-list-number">
                                    <span className="inv-title">
                                      Facture :{" "}
                                    </span>{" "}
                                    <span className="inv-number">
                                      {savedFacture.code}
                                    </span>
                                  </p>
                                  <p className="inv-list-number">
                                    <span className="inv-title">
                                      Journal :{" "}
                                    </span>{" "}
                                    <span className="inv-number">
                                      {" "}
                                      {savedFacture.journal?.code_journal}{" "}
                                    </span>
                                  </p>
                                </div>

                                <div className="col-sm-6 align-self-center mt-3">
                                  <p className="inv-street-addr"></p>

                                  <p className="inv-email-address">
                                    {savedFacture?.societe?.tel}
                                  </p>
                                </div>
                                <div className="col-sm-6 align-self-center mt-3 text-sm-right">
                                  <p className="inv-created-date">
                                    <span className="inv-title">
                                      Date Facture :{" "}
                                    </span>{" "}
                                    <span className="inv-date">
                                      {" "}
                                      {formadate(savedFacture.date)}{" "}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="inv--product-table-section">
                              <div className="table-responsive">
                                <table className="table">
                                  <thead className="">
                                    <tr>
                                      <th scope="col" style={{ width: "5%" }}>
                                        N°
                                      </th>
                                      <th scope="col" style={{ width: "10%" }}>
                                        Ref
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "20%" }}
                                      >
                                        Article
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "5%" }}
                                      >
                                        Qte
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Prix HT
                                      </th>

                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        TVA
                                      </th>

                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Total HT
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Total Net HT
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {savedFacture.items.map(
                                      (
                                        item: FactureItemType,
                                        index: number
                                      ) => {
                                        const codeArticle =
                                          item.item[0].product.code_article;

                                        return (
                                          <tr key={index}>
                                            <td> {index + 1} </td>
                                            <td>{codeArticle}</td>
                                            <td className="text-right">
                                              {item.item[0].product.titre.fr}
                                            </td>{" "}
                                            <td className="text-right">
                                              {item.item[0].quantity}
                                            </td>
                                            <td className="text-right">
                                              {item.item[0].product.prix_vente_ht.toFixed(
                                                3
                                              )}
                                            </td>
                                            <td className="text-right">
                                              {item.item[0].product.tva}
                                            </td>
                                            <td className="text-right">
                                              {" "}
                                              {item.item[0].product.remise}{" "}
                                            </td>
                                            <td className="text-right">
                                              {(
                                                item.item[0].product
                                                  .prix_vente_ht *
                                                item.item[0].quantity
                                              ).toFixed(3)}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div className="inv--total-amounts">
                              <div className="row mt-4">
                                <div className="col-sm-5 col-12 order-sm-0 order-1"></div>
                                <div className="col-sm-7 col-12 order-sm-1 order-0">
                                  <div className="text-sm-right">
                                    <div className="row">
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total HT : </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {" "}
                                          {savedFacture?.totalHt?.toFixed(
                                            3
                                          )}{" "}
                                        </p>
                                      </div>

                                      <div className="col-sm-8 col-7">
                                        <p className="">Total TTC </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {savedFacture.totalTTC?.toFixed(3)}{" "}
                                        </p>
                                      </div>
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total remises </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {savedFacture.totalRemises?.toFixed(
                                            3
                                          )}{" "}
                                        </p>
                                      </div>
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total Net </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {savedFacture.totalNet?.toFixed(3)}{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <table
                                border={1}
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Méthode</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{"Especes"}</td>
                                    <td>
                                      {savedFacture?.especes?.toFixed(3)} TND
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{"Chéques"}</td>
                                    <td>
                                      {savedFacture?.cheques?.toFixed(3)} TND
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{"Cartes bancaires"}</td>
                                    <td>
                                      {savedFacture?.cartes?.toFixed(3)} TND
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{"Tickets cadeaux"}</td>
                                    <td>
                                      {savedFacture?.tickets?.toFixed(3)} TND
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="invoice-inbox" ref={componentRef}>
                      <div id="ct" className="">
                        <div className="invoice-00001">
                          <div className="content-section">
                            <div className="inv--head-section inv--detail-section">
                              <div className="row">
                                <div className="col-sm-6 col-12 mr-auto">
                                  <div className="d-flex">
                                    {/* <img
                                    className="company-logo"
                                    src="/assets/assets/img/logo.png"
                                    alt="company"
                                  /> */}
                                    <h3 className="in-heading align-self-center">
                                      {journal?.organisation_id?.nom}
                                    </h3>
                                  </div>
                                </div>

                                <div className="col-sm-6 text-sm-right">
                                  <p className="inv-list-number">
                                    <span className="inv-title">
                                      Facture :{" "}
                                    </span>{" "}
                                    <span className="inv-number">#0001</span>
                                  </p>
                                  <p className="inv-list-number">
                                    <span className="inv-title">
                                      Journal :{" "}
                                    </span>{" "}
                                    <span className="inv-number">
                                      {" "}
                                      {journal?.code_journal}{" "}
                                    </span>
                                  </p>
                                </div>

                                <div className="col-sm-6 align-self-center mt-3">
                                  <p className="inv-street-addr" onClick={()=> console.log(products)}>
                                    XYZ Delta Street
                                  </p>
                                  <p className="inv-email-address">
                                    {user?.email}
                                  </p>
                                  <p className="inv-email-address">
                                    {journal?.organisation_id?.numero}
                                  </p>
                                </div>
                                <div className="col-sm-6 align-self-center mt-3 text-sm-right">
                                  <p className="inv-created-date">
                                    <span className="inv-title">
                                      Date Facture :{" "}
                                    </span>{" "}
                                    <span className="inv-date">
                                      {" "}
                                      {formadate(date)}{" "}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="inv--product-table-section">
                              <div className="table-responsive">
                                <table className="table">
                                  <thead className="">
                                    <tr>
                                      <th scope="col" style={{ width: "5%" }}>
                                        N°
                                      </th>
                                      <th scope="col" style={{ width: "10%" }}>
                                        Ref
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "20%" }}
                                      >
                                        Article
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "5%" }}
                                      >
                                        Qte
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Prix HT
                                      </th>

                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Total TTC
                                      </th>
                                      <th
                                        className="text-right"
                                        scope="col"
                                        style={{ width: "10%" }}
                                      >
                                        Total Net HT
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {!isPrinting
                                      ? products &&
                                        products.data &&
                                        Object.values(products.data).map(
                                          (item: any, index: number) => {
                                            const codeArticle =
                                              item?.product?.code_article;

                                            return (
                                              <tr key={index}>
                                                <td> {index + 1} </td>
                                                <td>{codeArticle}</td>
                                                <td className="text-right">
                                                  {!isPrinting ? (
                                                    <input
                                                      type="checkbox"
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          item?.product?._id
                                                        )
                                                      }
                                                      checked={checkedItems.includes(
                                                        item?.product?._id
                                                      )}
                                                    />
                                                  ) : null}{" "}
                                                  {item?.product?.titre?.fr}
                                                </td>{" "}
                                                <td className="text-right">
                                                  {item?.quantity}
                                                </td>
                                                <td className="text-right">
                                                  {item?.product?.prix_vente_ht?.toFixed(
                                                    3
                                                  )}
                                                </td>
                                                <td className="text-right">
                                                  {(
                                                    item.product
                                                      ?.prix_vente_ht *
                                                    item?.quantity
                                                  ).toFixed(3)}
                                                </td>
                                                <td className="text-right">
                                                  {" "}
                                                  {(item.product?.prix_vente_ht *
                                                    item?.quantity).toFixed(3)}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      : eliminateItemsFromArray1() &&
                                        eliminateItemsFromArray1().map(
                                          (item: any, index: number) => {
                                            const codeArticle =
                                              item?.product?.code_article;

                                            return (
                                              <tr key={index}>
                                                <td> {index + 1} </td>
                                                <td>{codeArticle}</td>
                                                <td className="text-right">
                                                  {!isPrinting ? (
                                                    <input
                                                      type="checkbox"
                                                      onChange={() =>
                                                        handleCheckboxChange(
                                                          item?.product?._id
                                                        )
                                                      }
                                                      checked={checkedItems.includes(
                                                        item?.product?._id
                                                      )}
                                                    />
                                                  ) : null}{" "}
                                                  {item?.product?.titre?.fr}
                                                </td>
                                                <td className="text-right">
                                                  {item?.product?.prix_vente_ht?.toFixed(
                                                    3
                                                  )}
                                                </td>
                                                <td className="text-right">
                                                  {item?.quantity}
                                                </td>

                                                <td className="text-right">
                                                  {(
                                                    item.product
                                                      ?.prix_vente_ht *
                                                    item?.quantity
                                                  ).toFixed(3)}
                                                </td>
                                                <td className="text-right">
                                                  {" "}
                                                  {(
                                                    item.product
                                                      ?.prix_vente_ttc *
                                                    item?.quantity
                                                  ).toFixed(3)}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div className="inv--total-amounts">
                              <div className="row mt-4">
                                <div className="col-sm-5 col-12 order-sm-0 order-1"></div>
                                <div className="col-sm-7 col-12 order-sm-1 order-0">
                                  <div className="text-sm-right">
                                    <div className="row">
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total HT : </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {" "}
                                          {products.totalHT?.toFixed(3)}{" "}
                                        </p>
                                      </div>

                                      <div className="col-sm-8 col-7">
                                        <p className="">Total TTC </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {products.totalTTC?.toFixed(3)}{" "}
                                        </p>
                                      </div>
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total remises </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {products.totalRemises?.toFixed(3)}{" "}
                                        </p>
                                      </div>
                                      <div className="col-sm-8 col-7">
                                        <p className="">Total Net </p>
                                      </div>
                                      <div className="col-sm-4 col-5">
                                        <p className="">
                                          {products.totalNet?.toFixed(3)}{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <table
                                border={1}
                                cellPadding="10"
                                style={{
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Méthode</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {products.payments &&
                                    Object.entries(products?.payments).map(
                                      ([method, amount]: any) => (
                                        <tr
                                          key={
                                            method === "Cash"
                                              ? "Espéces"
                                              : method
                                          }
                                        >
                                          <td>{method}</td>
                                          <td>{amount.toFixed(3)} TND</td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!savedFacture && (
                    <div className="row" style={{ justifyContent: "center" }}>
                      <button
                        className="btn btn-success mb-2"
                        style={{
                          width: "80%",
                          background: "#009688",
                        }}
                        onClick={(e) => {
                          setIsPrinting(!isPrinting);
                        }}
                      >
                        {isPrinting ? "Editer" : "Confirmer"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {savedFacture ? (
        <ReactToPrint
          trigger={() => (
            <button className="btn btn-primary" style={{ width: "100%" }}>
              Print
            </button>
          )}
          content={() => componentRef.current}
        />
      ) : (
        isPrinting && (
          <button
            className="btn btn-primary mb-2"
            style={{ width: "100%" }}
            onClick={() => {
              if (societe_id && id && user)
                saveFacture({
                  societe_id: societe_id,
                  date: new Date(),
                  journal_id: id,
                  code: generateUniqueCode(factures),
                  user_id: user._id,
                  cartes: products.payments["Carte bancaire"],
                  especes: products.payments["Espéces"],
                  cheques: products.payments["Chéque"],
                  tickets: products.payments["Tickets cadeaux"],
                  totalHt: products.totalHT,
                  totalTTC: products.totalTTC,
                  totalRemises: products.totalRemises,
                  totalNet: products.totalNet,
                });
            }}
          >
            Enregistrer
          </button>
        )
      )}
    </>
  );
};

export default FactureSansEspeces;
